<template>
    <span class="mint-checkbox" >
        <input type="checkbox" @change="change" :disabled="disabled" :checked="currentValue" class="mint-checkbox-input" >
        <span class="mint-checkbox-core"></span>
    </span>
</template>

<script>
    export default {
        name: "CheckBox",
        props:{
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            disabled:{
                type: Boolean,
                default: false
            }
        },
        data: function() {
          return {
              currentValue: this.value
          }
        },
        methods: {
            change (event) {
                if (this.disabled) {
                    return false;
                }
                const checked = event.target.checked;
                this.currentValue = checked;
                // const value = checked ? this.trueValue : this.falseValue;
                this.$emit('input', this.currentValue);
                // if (this.group) {
                //     this.parent.change(this.model);
                // } else {
                //     this.$emit('on-change', value);
                //     this.dispatch('FormItem', 'on-form-change', value);
                // }
                this.$emit('on-change', this.currentValue);
            }
        },
        watch: {
            value (val) {
                // if (val === this.trueValue || val === this.falseValue) {
                //     this.updateModel();
                // } else {
                //     throw 'Value should be trueValue or falseValue.';
                // }
            }
        }
    }
</script>

<style scoped>
    .mint-checkbox {
        position: relative;
    }
    .mint-checkbox-input {
        /*display: none;*/
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        opacity: 0;
    }
    .mint-checkbox-core {
        display: inline-block;
        background-color: #fff;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 20px;
        height: 20px;
        vertical-align: middle;
    }
    .mint-checkbox-core:after {
        border: 2px solid transparent;
        border-left: 0;
        border-top: 0;
        content: " ";
        top: 1px;
        left: 6px;
        position: absolute;
        width: 6px;
        height: 12px;
        -webkit-transform: rotate(45deg) scale(0);
        transform: rotate(45deg) scale(0);
        -webkit-transition: -webkit-transform .2s;
        transition: -webkit-transform .2s;
        transition: transform .2s;
        transition: transform .2s, -webkit-transform .2s;
    }
    .mint-checkbox-input:checked+.mint-checkbox-core {
        background-color: #26a2ff;
        border-color: #26a2ff;
    }
    .mint-checkbox-input:checked+.mint-checkbox-core:after {
        border-color: #fff;
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
    }

</style>